import { FunctionComponent } from "react";
import { Placeholder } from "@ppb/the-wall-web/components/bricks/Placeholder/Placeholder";
import styles from "./SelectableItemsCardGroupPlaceholder.web.css";

const SelectableItemsCardGroupPlaceholder: FunctionComponent = () => (
  <div className={styles.placeholder}>
    <Placeholder />
  </div>
);

export default SelectableItemsCardGroupPlaceholder;
